module.exports = __webpack_public_path__ + "static/img/6-1.cb956c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/6-1.jpg
// module id = NGb5
// module chunks = 0